import { render, staticRenderFns } from "./SummarySeparator.vue?vue&type=template&id=7b980216&functional=true"
import script from "./SummarySeparator.vue?vue&type=script&lang=js"
export * from "./SummarySeparator.vue?vue&type=script&lang=js"
import style0 from "./SummarySeparator.vue?vue&type=style&index=0&id=7b980216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports